// @ts-strict-ignore
import { HttpHeaders } from '@angular/common/http';
import { Project, UrlMap } from '../definitions';
import { environment } from '@env/environment';

/**
 *
 * TODO: Add a handler when there's a token mismatch
 * to not disrupt web api requests.
 *
 * TODO: Check if session has ended before executing any
 * service or entering a page that will require one.
 *
 * Check \App\Exceptions\Handler for details
 */
export class BaseService {
  // BASE URL
  protected baseUrlAdmin = environment['apiUrl'];
  protected baseUrlDashboard = `${window['BASE_URL']}/web-api`;

  protected get baseUrl(): string {
    return this.project === 'DASHBOARD' ? this.baseUrlDashboard : this.baseUrlAdmin;
  }

  // CSRF TOKEN
  protected csrfTokenAdmin = '';
  protected csrfTokenDashboard = window['APP_ENVIRONMENT']['CSRF_TOKEN'];

  protected get csrfToken(): string {
    return this.project === 'DASHBOARD' ? this.csrfTokenDashboard : this.csrfTokenAdmin;
  }

  // HEADERS
  protected headersAdmin = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  protected headersDashboard = new HttpHeaders({
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': this.getCSRFToken(),
    'X-XSRF-TOKEN': this.getCSRFToken(),
  });

  protected get headers(): HttpHeaders {
    return this.project === 'DASHBOARD' ? this.headersDashboard : this.headersAdmin;
  }

  // PDF HEADERS
  protected pdfHeadersAdmin = new HttpHeaders({
    accept: 'application/pdf',
  });

  protected pdfHeadersDashboard = new HttpHeaders({
    'X-CSRF-TOKEN': this.getCSRFToken(),
    accept: 'application/pdf',
  });

  protected get pdfHeaders(): HttpHeaders {
    return this.project === 'DASHBOARD' ? this.pdfHeadersDashboard : this.pdfHeadersAdmin;
  }

  // EXCEL HEADERS
  protected excelHeadersAdmin = new HttpHeaders({
    accept: 'application/vnd.ms-excel',
  });

  protected excelHeadersDashboard = new HttpHeaders({
    'X-CSRF-TOKEN': this.getCSRFToken(),
    accept: 'application/vnd.ms-excel',
  });

  protected get excelHeaders(): HttpHeaders {
    return this.project === 'DASHBOARD' ? this.excelHeadersDashboard : this.excelHeadersAdmin;
  }

  // OPTIONS
  protected httpOptions = {
    headers: this.headers,
  };

  protected blobOptions = {
    headers: this.pdfHeaders,
    responseType: 'blob' as 'blob',
  };

  protected observeBlobOptions = {
    headers: this.pdfHeaders,
    responseType: 'blob' as 'blob',
    observe: 'response' as 'response',
  };

  protected excelBlobOptions = {
    headers: this.excelHeaders,
    responseType: 'blob' as 'blob',
  };

  protected excelOptions = {
    headers: {
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;',
    },
    responseType: 'blob' as 'blob',
  };

  protected requestOptions = {
    headers: this.headers,
  };

  constructor(protected project: Project) {}

  protected getCSRFToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
  }

  /**
   * Error handler
   * @param  {any}          error The exception
   * @return {Promise<any>}       A promise to make the error handling request
   */
  protected handleError(error: any): Promise<any> {
    let body = error._body || error;

    console.log('Running handleError in base.ts');

    try {
      body = JSON.parse(body);
    } catch (e) {
      console.log('unparsable response');
    }

    if (body['error']) {
      if (body.error == 'UNAUTHENTICATED') {
        alert('UNAUTHENTICATED');

        if (body.redirect != '') {
          window.location.href = body.redirect;
        }
      } else if (body.error == 'TOKENMISMATCH') {
        alert('TOKENMISMATCH');
        // TODO: If reload becomes unreliable, we can try to make an http call
        // and replace the csrf cookie.
        window.location.reload();
      }
    }

    // TODO: let the server know there was an angular exception
    return Promise.reject(body);
  }

  protected getApiEndpoint(fn: string, map: UrlMap[]): string {
    const urls = map.find((m) => m.fn === fn);

    if (urls) {
      if (urls.url) {
        return `${this.baseUrl}/${urls.url}`;
      }

      const url = urls[this.project.toLowerCase()];

      if (url) {
        return `${this.baseUrl}/${url}`;
      }

      throw `Cannot determine url for project ${this.project} [${fn}()]`;
    }

    throw `Cannot determine urls for function "${fn}"`;
  }
}
